import { type ReactNode, useState } from "react";
import ComparisionDialog from "~/features/compareProducts/components/ComparisionDialog";
import { ComparisonDialogContext } from "~/features/compareProducts/context/ComparisonDialogContext";
import { closeProductComparisonDrawer } from "./ProductComparisonDrawerContainer";

export const ComparisonDialogProvider = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false);
  const closeComparison = () => {
    closeProductComparisonDrawer();
    setOpen(false);
  };
  return (
    <ComparisonDialogContext.Provider
      value={{
        showComparision: open,
        openComparisonDialog: () => setOpen(true),
        closeComparisonDialog: closeComparison,
      }}
    >
      {children}
      {open && <ComparisionDialog onClose={closeComparison} />}
    </ComparisonDialogContext.Provider>
  );
};
